import { useEffect } from 'react';
const handleKeyDown = (event) => {
    const activeElement = document.activeElement;
    const inputElementHasFocus = activeElement &&
        (['INPUT', 'TEXTAREA'].includes(activeElement.tagName) ||
            (activeElement instanceof HTMLElement && activeElement.contentEditable === 'true'));
    if (event.shiftKey && !inputElementHasFocus) {
        const requestStreemshotButton = document.querySelector('[data-testid="streemshot-button"]');
        const camaerFlipButton = document.querySelector('[data-testid="FlipIcon-icon-button"]');
        const laserToolButton = document.querySelector('[data-testid="laser-pointer-button"]');
        const markerToolButton = document.querySelector('[data-testid="marker-button"]');
        const trayToggleButton = document.querySelector('[data-testid="tray-toggle-button"]');
        const addBookmarkButton = document.querySelector('[data-testid="add-bookmark-button"]');
        const toggleCameraButton = document.querySelector('[data-testid="Start Camera"]') ??
            document.querySelector('[data-testid="Stop Camera"]');
        const toggleMuteButton = document.querySelector('[data-testid="Unmute"]') ??
            document.querySelector('[data-testid="Mute"]');
        if (toggleCameraButton && toggleCameraButton.click && event.key.toUpperCase() === 'V') {
            toggleCameraButton.click();
        }
        if (toggleMuteButton && toggleMuteButton.click && event.key.toUpperCase() === 'A') {
            toggleMuteButton.click();
        }
        if (trayToggleButton && trayToggleButton.click && event.key.toUpperCase() === 'T') {
            trayToggleButton.click();
        }
        if (requestStreemshotButton &&
            requestStreemshotButton.click &&
            event.key.toUpperCase() === 'S') {
            requestStreemshotButton.click();
        }
        if (markerToolButton && markerToolButton.click && event.key.toUpperCase() === 'D') {
            markerToolButton.click();
        }
        if (laserToolButton && laserToolButton.click && event.key.toUpperCase() === 'Z') {
            laserToolButton.click();
        }
        if (camaerFlipButton && camaerFlipButton.click && event.key.toUpperCase() === 'F') {
            camaerFlipButton.click();
        }
        if (addBookmarkButton && addBookmarkButton.click && event.key.toUpperCase() === 'B') {
            // Delay the click so that the current Shift+B key press doesn't enter into the text field
            setTimeout(() => {
                addBookmarkButton.click();
            }, 10);
        }
    }
};
export const useInCallShortcuts = () => {
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
};
//# sourceMappingURL=use_in_call_shortcuts.js.map